import React from 'react'
import {
  LayoutBand,
  H3,
  Subheading,
  Button,
  Separator,
  colors,
  Grid,
  Cell,
  usePageWidth,
  Image,
  Bleed,
} from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import gettingStartedImg from './images/getting-started-image.svg'

export default function GettingStarted() {
  const { t } = useTranslation()
  const atPageWidth = usePageWidth()
  const isMobile = atPageWidth({ default: true, lg: false })

  return (
    <LayoutBand color={colors.blue03} marginX="xl" style={{ overflow: 'hidden' }}>
      <Grid>
        <Bleed top columns={atPageWidth({ default: 12, lg: 7 })} order={isMobile ? 1 : 2}>
          <Image
            src={gettingStartedImg}
            alt=""
            aria-hidden
            noCrop
            style={{ width: !isMobile && 'calc(100% + 200px)', marginInlineStart: atPageWidth({ xl: '-10%' }) }}
          />
        </Bleed>
        <Cell columns={atPageWidth({ default: 12, lg: 5 })} alignY="middle">
          <Separator size={isMobile ? 'sm' : 'xl'} />
          <H3 size="H4">
            {t('nlihp.united-states.getting-started.heading', 'Not sure where to begin?')}
            <Subheading>
              {t(
                'nlihp.united-states.getting-started.subheading',
                'We can show you how to do things like make a family tree or search for an ancestor. Choose from a list of activities that fits your interest.'
              )}
            </Subheading>
          </H3>
          <Separator size="sm" />
          <Button
            emphasis="high"
            external
            to="/gettingstarted"
            color="gray"
            linkName="Choose your next step"
            target="_blank"
          >
            {t('nlihp.united-states.getting-started.choose-next-step', 'Choose your next step')}
          </Button>
          <Separator size="sm" />
        </Cell>
      </Grid>
      <Separator size="xl" />
    </LayoutBand>
  )
}
